export default {"src":"/_next/static/media/workwithpartner.75f2107e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};